import { Theme } from '@mui/material'

const useStyles = {
  modal: (theme: Theme) => ({
    zIndex: theme.zIndex.drawer + 2,
  }),
  paper: (isFullScreen: boolean) => ({
    display: 'flex',
    flexDirection: 'column',
    height: isFullScreen ? '100%' : 'auto',
  }),
  contentContainer: (theme: Theme) => ({
    padding: theme.spacing(3, 2),
    flex: 1,
    overflowY: 'auto',
    minHeight: 0,
  }),
  headerContainer: (theme: Theme) => ({
    backgroundColor: theme.palette.common.white,
  }),
  appBar: {
    boxShadow: 'none',
    backgroundColor: 'transparent',
    paddingX: 2,
  },
  toolbar: (theme: Theme) => ({
    gap: theme.spacing(2),
    padding: 0,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    [theme.breakpoints.up('sm')]: {
      paddingLeft: 0,
      paddingRight: 0,
    },
  }),
  spacer: {
    width: '48px',
  },
  dialogActions: (theme: Theme, hasMultipleActions: boolean) => ({
    backgroundColor: theme.palette.ui.surfaceContainer,
    padding: theme.spacing(4, 2, 4, 2),
    justifyContent: hasMultipleActions ? 'space-between' : 'center',
  }),
}

export default useStyles
